import * as actions from './service.actions';
import watch from './service.operations';
import reducer, { initState } from './service.reducers';

export { actions, initState, watch };

export default reducer;
